// Centralized API configuration for web-app-request
export const API_BASE_URL = "https://test-api.tringbox.com";

// Utility function to add query parameters to URLs
export const addQueryParams = (url, params) => {
  if (!params || Object.keys(params).length === 0) return url;

  const urlObj = new URL(url);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      urlObj.searchParams.set(key, value);
    }
  });

  return urlObj.toString();
};

// Centralized API endpoints
export const API_ENDPOINTS = {

  SEND_OTP: `${API_BASE_URL}/v1/auth/otp/send`,
  VERIFY_OTP: `${API_BASE_URL}/v1/auth/otp/verify`,
  RESEND_OTP: `${API_BASE_URL}/v1/auth/otp/resend`,

  // Partner endpoints
  PARTNER: `${API_BASE_URL}/v1/partner`,
  PARTNER_CONFIG: `${API_BASE_URL}/app/partner/config`,
  PARTNER_SESSION: `${API_BASE_URL}/v1/auth/partner/session`,
  PARTNER_UPLOAD_AVATAR: `${API_BASE_URL}/v1/partner/upload/avatar`,

  // Artist endpoints
  ARTIST_PROFILE: (artistId) => `${API_BASE_URL}/v1/artist/${artistId}`,
  ARTIST_ME: `${API_BASE_URL}/v1/artist/me`,
  ARTIST_UPDATE: (artistId) => `${API_BASE_URL}/v1/artist/${artistId}`,
  ARTIST_EVENTS: (artistId) => `${API_BASE_URL}/v1/artist/${artistId}/events`,
  ARTIST_CALENDAR: (artistId) =>
    `${API_BASE_URL}/v1/artist/${artistId}/calendar`,

  // Event endpoints
  EVENTS: `${API_BASE_URL}/v1/events`,
  EVENT: `${API_BASE_URL}/v1/event`,
  EVENT_DETAILS: (eventId) => `${API_BASE_URL}/v1/events/${eventId}`,
  EVENT_BY_ID: (eventId) => `${API_BASE_URL}/v1/event/${eventId}`,
  EVENT_CREATE: `${API_BASE_URL}/v1/events`,
  EVENT_UPDATE: (eventId) => `${API_BASE_URL}/v1/events/${eventId}`,
  EVENT_DELETE: (eventId) => `${API_BASE_URL}/v1/events/${eventId}`,
  EVENT_BOOK: (eventId) => `${API_BASE_URL}/v1/events/${eventId}/book`,
  EVENT_CANCEL: (eventId) => `${API_BASE_URL}/v1/events/${eventId}/cancel`,
  EVENT_PERFORMER: `${API_BASE_URL}/v1/event/performer`,
  EVENT_PERFORMER_ACTIVE: `${API_BASE_URL}/v1/event/performer/active`,
  EVENT_PERFORMER_BUSINESS: `${API_BASE_URL}/v1/event/performer?showBusiness=true`,
  EVENT_VENUE: (venueId, performerId) =>
    `${API_BASE_URL}/v1/event/venue/${venueId}?performerId=${performerId}`,
  EVENT_STATUS: (eventId) => `${API_BASE_URL}/v1/event/${eventId}/status`,

  // Ratings endpoints
  RATINGS: (partnerId) => `${API_BASE_URL}/v1/ratings/${partnerId}`,

  // partner gift
  PARTNER_GIFTS: `${API_BASE_URL}/v1/partner/user/gift`,

  // Transaction endpoints
  TRANSACTIONS_EARNINGS: `${API_BASE_URL}/v1/transactions/user/earnings`,

  // Support endpoints
  USERS_SUPPORT: `${API_BASE_URL}/v1/users/support`,

  // Venue endpoints
  VENUES: `${API_BASE_URL}/v1/venues`,
  VENUE_DETAILS: (venueId) => `${API_BASE_URL}/v1/venues/${venueId}`,
  VENUE_EVENTS: (venueId) => `${API_BASE_URL}/v1/venues/${venueId}/events`,
  VENUE_CALENDAR: (venueId) => `${API_BASE_URL}/v1/venues/${venueId}/calendar`,
  VENUE_PERFORMERS: `${API_BASE_URL}/v1/venues/performers`,

  // Business endpoints
  BUSINESS_LOGIN: `${API_BASE_URL}/v1/business/login`,
  BUSINESS_SIGNUP: `${API_BASE_URL}/v1/business/signup`,
  BUSINESS_PROFILE: (businessId) => `${API_BASE_URL}/v1/business/${businessId}`,
  BUSINESS_EVENTS: (businessId) =>
    `${API_BASE_URL}/v1/business/${businessId}/events`,

  // QR code endpoints
  QR_GENERATE: `${API_BASE_URL}/v1/qr/generate`,
  QR_SCAN: `${API_BASE_URL}/v1/qr/scan`,

  // Order endpoints (Waiter)
  ORDERS: `${API_BASE_URL}/v1/orders`,
  ORDER_DETAILS: (orderId) => `${API_BASE_URL}/v1/orders/${orderId}`,
  ORDER_UPDATE: (orderId) => `${API_BASE_URL}/v1/orders/${orderId}`,

  // subscription endpoints
  SUBSCRIPTION: `${API_BASE_URL}/v1/subscriptions`,
  ORDER_CONFIG: `${API_BASE_URL}/v1/order/config`,
  CANCEL_SUBSCRIPTION: `${API_BASE_URL}/v1/subscriptions/cancel`,
  // SUBSCRIPTION_PURCHASE: `${API_BASE_URL}/v1/subscription/purchase`,
  // SUBSCRIPTION_STATUS: `${API_BASE_URL}/v1/subscription/status`,

  // Generic endpoints
  UPLOAD: `${API_BASE_URL}/v1/upload`,
  SEARCH: `${API_BASE_URL}/v1/search`,

  // Statistics endpoints
  STATS: `${API_BASE_URL}/v1/stats`,
  ANALYTICS: `${API_BASE_URL}/v1/analytics`,

  // Additional Event Management
  EVENT_EXTEND: (eventId) => `${API_BASE_URL}/v1/event/${eventId}/extend`,
  EVENT_DETAILS: (eventId) => `${API_BASE_URL}/v1/event/${eventId}`,

  // Venue Management (Extended)
  VENUE: `${API_BASE_URL}/v1/venue`,
  VENUE_THEMES: `${API_BASE_URL}/v1/venue/themes`,
  VENUE_STATUS: (venueId) => `${API_BASE_URL}/v1/venue/${venueId}/status`,
  VENUE_QUEUE: (venueId) => `${API_BASE_URL}/v1/venue/${venueId}/queue`,
  VENUE_QUEUE_STATUS: (venueId) =>
    `${API_BASE_URL}/v1/venue/${venueId}/queue/status`,
  VENUE_APPROVED_PARTNER: (venueId) =>
    `${API_BASE_URL}/v1/venue/${venueId}/approved?isPartner=true`,
  VENUE_APPROVED: (venueId) => `${API_BASE_URL}/v1/venue/${venueId}/approved`,
  VENUE_PLAYBACK: (venueId, count = 100) =>
    `${API_BASE_URL}/v1/venue/${venueId}/playback?count=${count}`,
  VENUE_USERS_COUNT: (venueId) =>
    `${API_BASE_URL}/v1/venue/${venueId}/users/count`,
  VENUE_USERS: (venueId) => `${API_BASE_URL}/v1/venue/${venueId}/users`,
  VENUE_OVERVIEW: (venueId) => `${API_BASE_URL}/v1/venue/${venueId}/overview`,

  // Shout-out Management
  SHOUT_OUT_STATUS: (id) => `${API_BASE_URL}/v1/shout-out/${id}/status`,
  SHOUT_OUT_USERS_REQUEST: (id) =>
    `${API_BASE_URL}/v1/shout-out/${id}/users/request`,
  SHOUT_OUT_USERS_COUNT: (id) =>
    `${API_BASE_URL}/v1/shout-out/${id}/users/count`,
  SHOUT_OUT_USERS_HISTORY: (id) =>
    `${API_BASE_URL}/v1/shout-out/${id}/users/history`,
  SHOUT_OUT_EVENT_HISTORY: (eventId) =>
    `${API_BASE_URL}/v1/shout-out/event/${eventId}/history`,

  // Queue Management
  QUEUE_EVENT_HISTORY: (eventId) =>
    `${API_BASE_URL}/v1/queue/event/${eventId}/history`,

  // Transactions & Earnings (Extended)
  TRANSACTIONS_EVENT_EARNINGS: (eventId) =>
    `${API_BASE_URL}/v1/transactions/event/${eventId}/earnings`,

  // Owner endpoints
  OWNER_VENUES: `${API_BASE_URL}/v1/owner/venues`,
};
